module.exports = __webpack_public_path__ + "static/img/220.7286edb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200921/220.jpg
// module id = VjIK
// module chunks = 0